import { Card, CardBody, CardHeader, CardTitle, Loading } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import styled from 'styled-components';
import { LoadingWrapper } from '../LoadingWrapper';

export interface ICardLayoutProps {
	loading: boolean;
	title: string;
	header?: {};
}

const ContentContainer = styled.div.attrs<{ $loading: boolean }>({
	className: 'tws-content-container',
})<{ $loading: boolean }>`
	position: relative;
	width: ${(props) => (props.$loading ? '0' : 'auto')};
	opacity: ${(props) => (props.$loading ? 0 : 1)};
`;

export class CardLayout extends React.PureComponent<React.PropsWithChildren<ICardLayoutProps>, {}> {
	public render() {
		return (
			<Card>
				<CardHeader size='lg'>
					<CardTitle>{this.props.title}</CardTitle>
					{this.props.header}
				</CardHeader>
				<CardBody>
					{this.props.loading ? (
						<LoadingWrapper>
							<Loading height={'70px'} width={'70px'} />
						</LoadingWrapper>
					) : (
						<ContentContainer $loading={this.props.loading}>{this.props.children}</ContentContainer>
					)}
				</CardBody>
			</Card>
		);
	}
}
